import React from 'react';
import { connect } from 'react-redux';
import './Pricing.scss';

const Pricing = ({
  isExchange,
  exchangePrice,
  currencySymbol,
  exchangeMarketPrice,
  exchangeText,
  exchangeFreeText,
  productOfferIdDetails,
  finalprice,
  marketPrice,
  inclusiveText,
  dataLocale,
  localeInfo,
  blueStyle = {},
  greyStyle = {},
  secondaryStyle = {},
}) => {
  const tax = (dataLocale && dataLocale?.TAX) || 'tax';
  return (
    <>
      <div className="new-pricing">
        {isExchange && exchangePrice && (
          <>
            <span className="text-color-dark-blue" style={blueStyle}>
              {currencySymbol}
              {Math.round(exchangePrice.price)}
            </span>
            &nbsp;
            {exchangeMarketPrice.price > exchangePrice.price && (
              <span className="text-color-light-grey strike-through" style={greyStyle}>
                {currencySymbol}
                {exchangeMarketPrice.price}
              </span>
            )}
            <div className="mr-t4">
              <span className="exchange-price text-color-dark-blue">
                {exchangePrice && exchangePrice.price > 0 ? exchangeText : exchangeFreeText}
              </span>
            </div>
          </>
        )}
        {!isExchange && (
          <>
            {productOfferIdDetails && productOfferIdDetails.text1 && (
              <span className="text-color-dark-blue fw700" style={blueStyle}>
                {productOfferIdDetails.text1}
              </span>
            )}
            &nbsp;
            {
              <span className="text-color-dark-blue fw700" style={blueStyle}>
                {currencySymbol}
                {finalprice}
              </span>
            }
            &nbsp;
            <span className="text-color-light-grey" style={greyStyle}>
              {marketPrice > finalprice && (
                <span className="strike-through">
                  {currencySymbol}
                  {marketPrice}
                </span>
              )}{' '}
              {localeInfo && localeInfo?.countryCode.toLowerCase() === 'in' && (
                <span>(+{tax.toLowerCase()})</span>
              )}
            </span>
            <span className="text-color-light-secondary" style={secondaryStyle}>
              {' '}
              {inclusiveText}
            </span>
          </>
        )}
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {
    currencyMark: state.common.currencyMark,
    redisCommonData: state.common.redisCommonData,
  };
};

export default connect(mapStateToProps, null)(Pricing);
